export default "__VITE_ASSET__DAMenlMP__"